module.exports = __webpack_public_path__ + "img/guests.765b905d.svg";